import { createSelector } from "reselect";

const selectUser = (state) => state.user;

export const selectProduct = createSelector(
	[selectUser],
	(user) => user.product
);
export const selectAccessory = createSelector(
	[selectUser],
	(user) => user.accessory
);
export const selectCartTotal = createSelector([selectProduct], (product) =>
	product.reduce(
		(accumalatedQuantity, prod) =>
			accumalatedQuantity +
			prod.quantity * (prod.Price - (prod.offer / 100) * prod.Price).toFixed(0),
		0
	)
);

export const selectCartItemCount = createSelector([selectProduct], (product) =>
	product.reduce(
		(accumalatedQuantity, product) => accumalatedQuantity + product.quantity,
		0
	)
);

export const selectLocation = createSelector(
	[selectUser],
	(user) => user.location
);
